'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createBus = exports.createBus = function createBus() {
  var getId = function getId() {
    return nextId++;
  };
  var addChannelSubscriber = function addChannelSubscriber(channel, fn, filterFn, once) {
    subscriptions[channel] = subscriptions[channel] || {};
    var id = getId();
    var stopFn = createStopFn(channel, id);
    var newFn = once !== true ? fn : function (message) {
      return stopFn() && fn(message);
    };
    subscriptions[channel][id] = { fn: newFn, filterFn: filterFn || function () {
        return true;
      } };
    return stopFn;
  };
  var createStopFn = function createStopFn(channel, id) {
    return function () {
      return delete subscriptions[channel][id];
    };
  };
  var getChannelSubscribers = function getChannelSubscribers(channel) {
    return (Object.keys(subscriptions[channel] || {}) || []).map(function (key) {
      return subscriptions[channel][key];
    });
  };
  var sendMessageToSubscribers = function sendMessageToSubscribers(channel, message) {
    getChannelSubscribers('*').concat(getChannelSubscribers(channel)).forEach(function (sub) {
      sub.filterFn(message) && sub.fn(message);
    });
  };
  var sendMessageToMiddlewares = function sendMessageToMiddlewares(channel, message, source) {
    middlewares.forEach(function (mw) {
      mw(channel, message, source);
    });
  };
  var wrapReduxMiddleware = function wrapReduxMiddleware(mw) {
    return function (send) {
      var dispatch = function dispatch(action) {
        return send(action.type, action);
      };
      var store = { getState: function getState() {
          return null;
        }, dispatch: dispatch };
      var partialMw = mw(store);
      return function (channel, message, source) {
        var action = Object.assign({}, message, { type: channel, source: source });
        var next = function next(a) {
          return a;
        };
        partialMw(next)(action);
      };
    };
  };

  var reset = function reset() {
    return Object.keys(subscriptions).forEach(function (key) {
      return delete subscriptions[key];
    });
  };
  var take = function take(channel, fn) {
    var filterFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!channel || !fn) return false;
    return addChannelSubscriber(channel, fn, filterFn, once);
  };
  var one = function one(channel, fn, filterFn) {
    return take(channel, fn, filterFn, true);
  };
  var send = function send(channel, message) {
    var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'app';

    if (!channel) return;
    sendMessageToSubscribers(channel, message);
    sendMessageToMiddlewares(channel, message, source);
  };
  var _self = function _self(channel, message, fn) {
    var $$responseChannel = 'SELF_REF_' + getId();
    one($$responseChannel, fn);
    send(channel, Object.assign({}, message, { $$responseChannel: $$responseChannel }));
  };

  // Local variables / constants
  var nextId = 0;
  var subscriptions = {};
  var middlewares = [];
  var _originObject = { '$$origin': 'suber' };

  // Exposed functions
  return {
    reset: reset,
    take: take,
    one: one,
    send: send,
    self: _self,
    applyMiddleware: function applyMiddleware() {
      Array.from(arguments).forEach(function (arg) {
        return middlewares.push(arg(send, _originObject));
      });
    },
    applyReduxMiddleware: function applyReduxMiddleware() {
      Array.from(arguments).forEach(function (arg) {
        var compat = wrapReduxMiddleware(arg)(send);
        middlewares.push(compat);
      });
    },
    resetMiddlewares: function resetMiddlewares() {
      middlewares = [];
    }
  };
};
var createReduxMiddleware = exports.createReduxMiddleware = function createReduxMiddleware(bus) {
  return function () {
    return function (next) {
      return function (action) {
        var res = next(action);
        if (!_isSuberOrigin(action)) bus.send(action.type, action, 'redux');
        return res;
      };
    };
  };
};

var _isSuberOrigin = function _isSuberOrigin(action) {
  return action['$$origin'] && action['$$origin'] === 'suber';
};


//////////////////
// WEBPACK FOOTER
// ../suber/lib/bus.js
// module id = 1618
// module chunks = 25